export default {
    invoiceDevice: {}
};